import * as React from 'react';

import {
    Props,
} from 'one-ui';

export interface ValueProps extends Props {
    label: string;
    value?: string;
}

export const Value = ({
    label,
    value,
}: ValueProps) => (
        <div className="values__value" style={{ wordBreak: 'break-all' }}>
            <b>
                {label}:
            </b>
            &nbsp;{value}
        </div>
    );
